import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  injectStripe,
  CardNumberElement,
  CardCVCElement,
  CardExpiryElement,
  PostalCodeElement
} from 'react-stripe-elements';

import { addStripeCard } from '../../../actions/stripeCardActions';

import Loading from '../../Loading/Loading';

import './PaymentMethodForm.css';

class PaymentMethodForm extends Component {
  constructor() {
    super();

    this.state = {
      errors: {
        cardNumber: null,
        cvc: null,
        expiry: null,
        postal: null,
        customer: 'Invalid stripe customer'
      }
    };

    this.handleChangeFor.bind(this);
  }

  handleFormSubmit = (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    // Within the context of `Elements`, this call to createToken knows
    // which Element(s) to tokenize
    this.props.stripe.createToken().then(response => {
      const { token } = response;

      if (token) {
        this.handleAddStripeCard(token);
      } else {
        this.styleElements();
      }
    });
  }

  handleChangeFor = (type) => {
    return ({ error }) => {
      const { errors } = this.state;

      // if error exists update this field's error message
      if (error) {
        errors[type] = error.message;
      } else {
        errors[type] = null;
      }

      this.setState({ errors });
    };
  }

  handleAddStripeCard = (token) => {
    const { customer, addStripeCard: addStripeCardFn } = this.props;

    if (customer.stripeCustomerId) {
      addStripeCardFn(customer.stripeCustomerId, token.id, () => {
        this.props.close();
      });
    } else {
      this.renderAlert('customer');
    }
  }

  styleElements = () => {
    // get an array of all 'div.form-group' elements in the form
    const formGroups = this.paymentMethodForm.getElementsByClassName('form-group');

    // set has-success/has-error based on the form-group
    // based on the class of the child span element
    // form-control-success and form-control-danger are inserted by
    // react-stripe-elements based on classOverrides
    _(formGroups).forEach(group => {
      if (group.getElementsByClassName('form-control-success').length > 0) {
        group.classList.add('has-success');
        group.classList.remove('has-error'); // bootstrap-3 class
        group.classList.remove('has-danger'); // bootstrap-4 class
      } else if (group.getElementsByClassName('form-control-danger').length > 0) {
        group.classList.remove('has-success');
        group.classList.add('has-error'); // bootstrap-3 class
        group.classList.add('has-danger'); // bootstrap-4 class
      } else {
        group.classList.remove('has-success');
        group.classList.remove('has-error'); // bootstrap-3 class
        group.classList.remove('has-danger'); // bootstrap-4 class
      }
    });
  }

  renderAlert(type) {
    // if errors contains the correct type, return a help-block
    // replace 'form-control-feedback' with 'help-block' for Bootstrap 3
    if (this.state.errors && this.state.errors[type]) {
      return <span className="form-control-feedback">{this.state.errors[type]}</span>;
    }

    return null;
  }

  render() {
    const { stripeCards } = this.props;

    const classOverrides = {
      base: 'form-control',
      complete: 'form-control-success',
      empty: 'form-control-empty',
      invalid: 'form-control-danger invalid'
    };

    return (
      <form
        id="payment-method-form"
        className="PaymentMethodForm"
        onSubmit={this.handleFormSubmit.bind(this)}
        ref={form => {
          this.paymentMethodForm = form;
        }}
      >
        <div className="form-row">
          <div className="form-group col">
            <label htmlFor="cardnumber">Card Number</label>

            <CardNumberElement
              classes={classOverrides}
              onChange={this.handleChangeFor('cardNumber')}
              onBlur={this.styleElements.bind(this)}
            />

            {this.renderAlert('cardNumber')}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-12 col-sm-6">
            <label htmlFor="exp-date">Expires On</label>

            <CardExpiryElement
              classes={classOverrides}
              onChange={this.handleChangeFor('expiry')}
              onBlur={this.styleElements.bind(this)}
            />

            {this.renderAlert('expiry')}
          </div>

          <div className="form-group col-12 col-sm-6">
            <label htmlFor="cvc">Security Code (CVC)</label>

            <CardCVCElement
              classes={classOverrides}
              onChange={this.handleChangeFor('cvc')}
              onBlur={this.styleElements.bind(this)}
            />

            {this.renderAlert('cvc')}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-12 col-sm-6">
            <label htmlFor="postal">Postal Code/Zip Code</label>

            <PostalCodeElement
              classes={classOverrides}
              onChange={this.handleChangeFor('postal')}
              onBlur={this.styleElements.bind(this)}
            />

            {this.renderAlert('postal')}
          </div>
        </div>

        {stripeCards.edit_status === 'fail' && (
          <p className="text-danger px-3">
            <small>{stripeCards.edit_error}</small>
          </p>
        )}

        <div className="form-group d-flex">
          {stripeCards.edit_status === 'loading' ? (
            <Loading className="ml-auto" size="small" />
          ) : (
            <Fragment>
              <button
                className="btn btn-secondary ml-auto mr-1"
                type="button"
                onClick={event => this.props.close(event)}
              >
                Cancel
              </button>

              <button className="btn btn-primary" type="submit">
                Add Card
              </button>
            </Fragment>
          )}
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    customer: state.user.profile,
    stripeCards: state.stripeCards
  };
}

export default compose(
  injectStripe,
  connect(
    mapStateToProps,
    {
      addStripeCard
    }
  )
)(PaymentMethodForm);



// WEBPACK FOOTER //
// ./src/components/forms/PaymentMethodForm/PaymentMethodForm.js